export default __webpack_public_path__ + "static/media/sahayaklogo.b0f3cbf9.png";